import React from "react";

import SiteHeader from "components/layout/SiteHeader";
import SiteFooter from "components/layout/SiteFooter";
import BackToTop from "components/BackToTop";

// Page shell for signed-in pages, same as the frontpage's SiteLayout:
// header, the page, footer, back-to-top.
export default function PageLayout({ className = "", children }) {
  return (
    <div className={`yc-app ${className}`}>
      <SiteHeader />
      <div className="yc-app-main">{children}</div>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}
